import type * as React from 'react';
import { OverflowTooltip } from '@/components/ui/OverflowTooltip';

export const TextCell = ({ value }: { value?: React.ReactNode }) =>
  value && <OverflowTooltip>{value}</OverflowTooltip>;
